import { createContext, useContext, useMemo, useRef, useState } from 'react';

import type { GridApi } from 'ag-grid-community';

type FreezeGridContextValue = {
  gridApi: GridApi | null;
  setGridApi: (api: GridApi | null) => void;
  isExpanded: boolean;
  setIsExpanded: (expanded: boolean) => void;
  isUpdateRunning: boolean;
  setIsUpdateRunning: (running: boolean) => void;
  gridRef: React.RefObject<HTMLDivElement | null>;
};

const FreezeGridContext = createContext<FreezeGridContextValue | null>(null);

export function FreezeGridProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [gridApi, setGridApi] = useState<GridApi | null>(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isUpdateRunning, setIsUpdateRunning] = useState(false);
  const gridRef = useRef<HTMLDivElement | null>(null);

  const value = useMemo(
    () => ({
      gridApi,
      setGridApi,
      isExpanded,
      setIsExpanded,
      isUpdateRunning,
      setIsUpdateRunning,
      gridRef,
    }),
    [gridApi, isExpanded, isUpdateRunning],
  );

  return (
    <FreezeGridContext.Provider value={value}>
      {children}
    </FreezeGridContext.Provider>
  );
}

export function useFreezeGrid() {
  const ctx = useContext(FreezeGridContext);
  if (!ctx) {
    throw new Error('useFreezeGrid must be used within FreezeGridProvider');
  }
  return ctx;
}
